const styles = theme => ({
  about: {
    lineHeight: "30px", 
    "& h1": {
      color: theme.colors.primary,
      textAlign: "center",
    },
    "& p": {
      textAlign: "justify"
    },  
  },

  // [theme.breakpoints.down('md')]: {
  //   abou
  //   background: 'blue'
  // },
});
export default styles;
